import { DriverBehaviorField } from '@/forms-legacy'

import { useTexts } from '../hooks/useTexts'

export function Braking() {
  const texts = useTexts()

  return (
    <DriverBehaviorField
      name="device.braking"
      testid="device.braking"
      label={texts.braking}
      labelHard={texts.gals(texts.hard)}
      labelHarsh={texts.gals(texts.harsh)}
      labelSevere={texts.gals(texts.severe)}
    />
  )
}
